<template>
    <mdb-container fluid>    
        <mdb-row class="justify-content-md-center">
           <mdb-col lg="10" sm="10" class="text-left content-top-btm-space"> 
                <mdb-row class="content-top-btm-space">
                    <mdb-col sm="9" class="text-left">
                        <span v-if="content_ld_flag==false" class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                        <main-content v-on:content_ld_flag_changed="updateContentLdFlag" v-on:content_ld_flag_false="resetContentLdFlag"/>
                    </mdb-col>
                    <mdb-col sm="3">
                        <span v-if="center_ld_flag==false" class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                        <centers-block v-on:center_ld_flag_changed="updateCenterLdFlag"/>
                        <br/>
                        <span v-if="favourite_ld_flag==false" class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                        <favorite-content v-on:favorite_ld_flag_changed="updateFavoriteLdFlag"/>
                    </mdb-col>
                   
                </mdb-row> 
           </mdb-col>  

                <!-- bottom content same from home page included-->
                    <mdb-col lg="10" >
                        <mdb-card-group deck>
                            <new-details></new-details>
                            <twitter-feed></twitter-feed>
                            <tag-clouds></tag-clouds>
                        </mdb-card-group>    
                    </mdb-col>    
                
        </mdb-row>
        
  </mdb-container>
</template>
<script>
import MainContent from '@/components/ThemeMDB/pages/modulePage/partials/MainContent';
import CentersBlock from '@/components/ThemeMDB/pages/partialsCommon/CentersBlock';
import FavoriteContent from '@/components/ThemeMDB/pages/partialsCommon/FavoriteContent';

import TagClouds from '@/components/ThemeMDB/home/partials/TagClouds';
import TwitterFeed from '@/components/ThemeMDB/home/partials/TwitterFeed';
import NewDetails from '@/components/ThemeMDB/home/partials/NewDetails';

import { mdbRow, mdbContainer, mdbCol, mdbCardGroup } from 'mdbvue';
export default {
    name: 'Body',
    data(){
        return{
            content_ld_flag:false,
            center_ld_flag:false,
            favourite_ld_flag:false
        }        
    },
    components:{
        MainContent,TagClouds,TwitterFeed,NewDetails,
        CentersBlock,FavoriteContent,
        mdbContainer,
        mdbRow,
        mdbCol,
        mdbCardGroup
    },
    methods:{
        updateContentLdFlag() {
            this.content_ld_flag=true
        },
        updateCenterLdFlag() {
            this.center_ld_flag=true
        },
        resetContentLdFlag() {
            this.content_ld_flag=false
        },
         updateFavoriteLdFlag() {
            this.favourite_ld_flag=true
        }
    } 
};

</script>
<style scoped>
.content-top-btm-space{
    padding: 55px 0;
}
h2{color: #276d96c7;}
</style>
